import { onSignalREvent } from '../../signalRBus'
import { useAuthStore } from 'src/common/store'
import { useNotificationStore } from 'src/stores'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'

onSignalREvent(
  SIGNAL_R_SCOPES.notification,
  SIGNAL_R_MESSAGES.clearedNotification,
  async (text) => {
    const authStore = useAuthStore()
    if (authStore.isSuperAdmin) return
    const notificationStore = useNotificationStore()
    const entityId = text
    notificationStore.clearEntity(entityId)
  },
)
